import styled from "styled-components";


export const ShowMissionPdfWrapper = styled.div``;